import { Injectable } from "@angular/core";
import { timeout, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { HttpClient, HttpHandler } from "@angular/common/http";
import { Observable } from "rxjs";
import { Constants } from "@constants";
import { LoaderService } from "./services/loader.service";

@Injectable()
export class HttpClientExtended extends HttpClient {
    public LoaderActivo = true;

    constructor(handler: HttpHandler, public loaderService: LoaderService, public router: Router) {
        super(handler);
    }

    public get(url: string, options?): Observable<any> {
        this.mostrarLoader();
        return super.get(url, options).pipe(
            (url.includes(`bigml`)) ? timeout(6000000) : timeout(60000),
            finalize(() => {
                this.ocultarLoader();
            }));
    }

    public post(url: string, body: any, options?): Observable<any> {
        this.mostrarLoader();
        return super.post(url, body, options).pipe(
            url.includes("combo-bulk-clone") || url.includes("/prize-exchanges/deliver_all") ?
                timeout(6000000) : (url.includes(`bigml`) ?
                    timeout(180000000) : timeout(60000)),
            finalize(() => {
                this.ocultarLoader();
            }));
    }

    public put(url: string, body: any, options?): Observable<any> {
        this.mostrarLoader();
        return super.put(url, body, options).pipe(
            timeout(60000),
            finalize(() => {
                this.ocultarLoader();
            }));
    }

    public deleteResponse(url: string): Observable<any> {
        this.mostrarLoader();
        return super.delete(url, { observe: "response" }).pipe(
            timeout(600000),
            finalize(() => {
                this.ocultarLoader();
            }));
    }

    public delete(url: string): Observable<any> {
        this.mostrarLoader();
        return super.delete(url).pipe(
            timeout(60000),
            finalize(() => {
                this.ocultarLoader();
            }));
    }

    public ocultarLoader() {
        this.loaderService.ocultarLoader();
    }

    public mostrarLoader() {
        this.loaderService.mostrarLoader();
    }
}
